import { SchedulingType } from '../../../../../common/constants';
import { Base, ControlProperty } from '../../../../../common/models';
import { BooleanValues, DraggableFilterType } from '../../../../constants';

export enum RuleListFilterName {
  RuleName = 'ruleName',
  CarrierName = 'carrierName',
  CarrierId = 'carrierExtId',
  CarrierNumber = 'carrierNumber',
  AddressName = 'addressName',
  AddressId = 'addressExtId',
  DockName = 'dockName',
  DockAllocationStartTime = 'dockAllocationStartTime',
  DockAllocationEndTime = 'dockAllocationEndTime',
  ValidityStartDate = 'validFrom',
  ValidityEndDate = 'validTo',
  RuleSchedulingType = 'schedulingType',
  ErpRelated = 'erpRelated',
  AddressPoint = 'sapClientViews',
}

export const RULE_FILTER_TYPE_BY_NAME: Map<RuleListFilterName, DraggableFilterType> = new Map([
  [RuleListFilterName.RuleName, DraggableFilterType.Input],
  [RuleListFilterName.CarrierName, DraggableFilterType.Input],
  [RuleListFilterName.CarrierId, DraggableFilterType.Input],
  [RuleListFilterName.CarrierNumber, DraggableFilterType.Input],
  [RuleListFilterName.AddressName, DraggableFilterType.Input],
  [RuleListFilterName.AddressId, DraggableFilterType.Input],
  [RuleListFilterName.DockName, DraggableFilterType.Input],
  [RuleListFilterName.DockAllocationStartTime, DraggableFilterType.TimePicker],
  [RuleListFilterName.DockAllocationEndTime, DraggableFilterType.TimePicker],
  [RuleListFilterName.ValidityStartDate, DraggableFilterType.Datepicker],
  [RuleListFilterName.ValidityEndDate, DraggableFilterType.Datepicker],
  [RuleListFilterName.RuleSchedulingType, DraggableFilterType.DropDownSelect],
  [RuleListFilterName.ErpRelated, DraggableFilterType.DropDownSelect],
  [RuleListFilterName.AddressPoint, DraggableFilterType.MultipleSelect],
]);

export const RULE_FILTER_SELECT_OPTIONS_BY_NAME = new Map<RuleListFilterName, string[] | Base[]>([
  [RuleListFilterName.RuleSchedulingType, Object.values(SchedulingType)],
  [RuleListFilterName.ErpRelated, Object.values(BooleanValues)],
  [RuleListFilterName.AddressPoint, []],
]);

export const RULE_FILTER_RADIO_OPTIONS_BY_NAME = new Map<RuleListFilterName, string[]>([]);

export class RuleListFiltersModelBase {
  [RuleListFilterName.RuleName]: string = null;
  [RuleListFilterName.CarrierName]: string = null;
  [RuleListFilterName.CarrierId]: number = null;
  [RuleListFilterName.CarrierNumber]: string = null;
  [RuleListFilterName.AddressName]: string = null;
  [RuleListFilterName.AddressId]: string = null;
  [RuleListFilterName.DockName]: string = null;
  [RuleListFilterName.DockAllocationStartTime]: string = null;
  [RuleListFilterName.DockAllocationEndTime]: string = null;
  [RuleListFilterName.ValidityStartDate]: string = null;
  [RuleListFilterName.ValidityEndDate]: string = null;
  [RuleListFilterName.RuleSchedulingType]: string = null;
  [RuleListFilterName.ErpRelated]: boolean = null;
  [RuleListFilterName.AddressPoint]: Base[] = [];

  constructor(params?: RuleListFiltersModelBase) {
    if (params) {
      Object.assign(this, params);
    }
  }
}
export class RuleListFilterForm {
  constructor(
    model: RuleListFiltersModelBase,

    public ruleName: ControlProperty<string> = [model.ruleName, []],
    public carrierName: ControlProperty<string> = [model.carrierName, []],
    public carrierExtId: ControlProperty<number> = [model.carrierExtId, []],
    public carrierNumber: ControlProperty<string> = [model.carrierNumber, []],
    public addressName: ControlProperty<string> = [model.addressName, []],
    public addressExtId: ControlProperty<string> = [model.addressExtId, []],
    public dockName: ControlProperty<string> = [model.dockName, []],
    public dockAllocationStartTime: ControlProperty<string> = [model.dockAllocationStartTime, []],
    public dockAllocationEndTime: ControlProperty<string> = [model.dockAllocationEndTime, []],
    public validFrom: ControlProperty<string> = [model.validFrom, []],
    public validTo: ControlProperty<string> = [model.validTo, []],
    public schedulingType: ControlProperty<string> = [model.schedulingType, []],
    public erpRelated: ControlProperty<boolean> = [model.erpRelated, []],
    public sapClientViews: ControlProperty<Base[]> = [model.sapClientViews, []],
  ) {}
}
